import { CIMSModule } from '../../CIMSModule'
import { CIMSPageItem } from '../CIMSPageItem'

export const DeveloperSnapshots = new CIMSPageItem({
  id: 'b0f76e0d-9069-4bd5-a07b-9c68f425b146',
  module: CIMSModule.Developer,
  name: 'Snapshots',
  pathname: 'snapshots',
})

export const UserSync = new CIMSPageItem({
  id: '53140d6a-9fd7-400b-ab4c-f059fd2c461c',
  module: CIMSModule.Developer,
  name: 'User Sync',
  pathname: 'user-sync',
})

export const Developers = new CIMSPageItem({
  id: 'ba9e3197-f2b4-40f7-a579-9f9e6407a93f',
  module: CIMSModule.Developer,
  name: 'Developers',
  pathname: 'developers',
})

export const Redis = new CIMSPageItem({
  id: '20b0046e-ed01-4aa6-86e3-be5838dddb04',
  module: CIMSModule.Developer,
  name: 'Redis',
  pathname: 'redis',
})

export const AssociateProject = new CIMSPageItem({
  id: '58310546-3ef7-4542-ba6d-767aebee4c2c',
  module: CIMSModule.Developer,
  name: 'Associate Project',
  pathname: 'associate-project',
})

export const Workflows = new CIMSPageItem({
  id: '4e76e109-1153-4420-8f0f-de1bd9796423',
  module: CIMSModule.Developer,
  name: 'Workflows',
  pathname: 'workflows',
})

export type DeveloperPageItem =
  | typeof DeveloperSnapshots
  | typeof UserSync
  | typeof Developers
  | typeof Redis
  | typeof AssociateProject
  | typeof Workflows
